"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GEO_NOTARIZATION_INFO = exports.LienRecordingFormat = void 0;
const homeState_1 = require("../origination/homeState");
const notarization_1 = require("./notarization");
/** @TranslateToPython */
var LienRecordingFormat;
(function (LienRecordingFormat) {
    LienRecordingFormat["PAPER"] = "PAPER";
    LienRecordingFormat["ELECTRONIC"] = "ELECTRONIC";
})(LienRecordingFormat || (exports.LienRecordingFormat = LienRecordingFormat = {}));
/**
 * @TranslateToPython
 */
exports.GEO_NOTARIZATION_INFO = [
    {
        county: 'autauga',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baldwin',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barbour',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bibb',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blount',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bullock',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chambers',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chilton',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'choctaw',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clarke',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cleburne',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coffee',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'colbert',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'conecuh',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coosa',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'covington',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crenshaw',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cullman',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dale',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dallas',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dekalb',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elmore',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'escambia',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'etowah',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'geneva',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hale',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'houston',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lamar',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lauderdale',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'limestone',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lowndes',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macon',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marengo',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mobile',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pickens',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'russell',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. clair',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sumter',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'talladega',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tallapoosa',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tuscaloosa',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walker',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilcox',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winston',
        state: homeState_1.StateTwoLetterCodes.alabama,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aleutian islands',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aleutians east',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aleutians west',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anchorage',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barrow',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bethel',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bristol bay',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cape nome',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chitina',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chugach',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cordova',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairbanks',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairbanks north star',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ft. gibbon',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haines',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'homer',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hoonah-angoon census area',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'illiamna',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'juneau',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kenai',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kenai peninsula',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ketchikan',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ketchikan gateway',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kodiak',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kodiak island',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kotzebue',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kusilvak',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kuskokwim',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kvichak',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manley hot springs',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'matanuska-susitna',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mt. mckinley',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nenana',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nome',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'north slope',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northwest arctic',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nulato',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'palmer',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'petersburg',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prince of wales-hyder',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rampart',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seldovia',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seward',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sitka',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sitka city and boro',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'skagway',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'southeast fairbanks',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'talkeetna',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'valdez',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'valdez-cordova',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wrangell',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yukon-koyukuk',
        state: homeState_1.StateTwoLetterCodes.alaska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'apache',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cochise',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coconino',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gila',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'graham',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greenlee',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'la paz',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'maricopa',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mohave',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'navajo',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pima',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pinal',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'santa cruz',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yavapai',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yuma',
        state: homeState_1.StateTwoLetterCodes.arizona,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'arkansas',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ashley',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baxter',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bradley',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chicot',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cleburne',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cleveland',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'conway',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'craighead',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crittenden',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cross',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dallas',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'desha',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'drew',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'faulkner',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garland',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hempstead',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hot spring',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howard',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'independence',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'izard',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lafayette',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'little river',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lonoke',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miller',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mississippi',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nevada',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newton',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ouachita',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'phillips',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'poinsett',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pope',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prairie',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pulaski',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. francis',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saline',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'searcy',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sebastian',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sevier',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sharp',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stone',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'van buren',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'white',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woodruff',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yell',
        state: homeState_1.StateTwoLetterCodes.arkansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alameda',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2021001365',
        fictitiousDeedOfTrustDate: '1/4/2021',
        fictitiousDeedOfTrustFilename: 'alameda.pdf',
    },
    {
        county: 'alpine',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'amador',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butte',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '2020-0050066',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'butte.pdf',
    },
    {
        county: 'calaveras',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2021-001184',
        fictitiousDeedOfTrustDate: '1/13/21',
        fictitiousDeedOfTrustFilename: 'calaveras.pdf',
    },
    {
        county: 'colusa',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'contra costa',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '2021-0077691',
        fictitiousDeedOfTrustDate: '3/15/2021',
        fictitiousDeedOfTrustFilename: 'contraCosta.pdf',
    },
    {
        county: 'del norte',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'el dorado',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0070859',
        fictitiousDeedOfTrustDate: '12/7/2020',
        fictitiousDeedOfTrustFilename: 'elDorado.pdf',
    },
    {
        county: 'fresno',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '2020-0175968',
        fictitiousDeedOfTrustDate: '12/7/2020',
        fictitiousDeedOfTrustFilename: 'fresno.pdf',
    },
    {
        county: 'glenn',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'humboldt',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'imperial',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'inyo',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kern',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '221131950',
        fictitiousDeedOfTrustDate: '7/15/2021',
        fictitiousDeedOfTrustFilename: 'kern.pdf',
    },
    {
        county: 'kings',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lassen',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'los angeles',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '20210135753',
        fictitiousDeedOfTrustDate: '1/25/2021',
        fictitiousDeedOfTrustFilename: 'losangeles.pdf',
    },
    {
        county: 'madera',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020031330',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'madera.pdf',
    },
    {
        county: 'marin',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0061037',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'marin.pdf',
    },
    {
        county: 'mariposa',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mendocino',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'merced',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '2020046281',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'merced.pdf',
    },
    {
        county: 'modoc',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '20200003383',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'modoc.pdf',
    },
    {
        county: 'mono',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020006058',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'mono.pdf',
    },
    {
        county: 'monterey',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020075512',
        fictitiousDeedOfTrustDate: '12/17/2020',
        fictitiousDeedOfTrustFilename: 'monterey.pdf',
    },
    {
        county: 'napa',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0032109',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'napa.pdf',
    },
    {
        county: 'nevada',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '20200033187',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'nevada.pdf',
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020000716104',
        fictitiousDeedOfTrustDate: '12/7/2020',
        fictitiousDeedOfTrustFilename: 'orange.pdf',
    },
    {
        county: 'placer',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0148312-00',
        fictitiousDeedOfTrustDate: '12/17/2020',
        fictitiousDeedOfTrustFilename: 'placer.pdf',
    },
    {
        county: 'plumas',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'riverside',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0606773',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'riverside.pdf',
    },
    {
        county: 'sacramento',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '202012071264',
        fictitiousDeedOfTrustDate: '12/7/2020',
        fictitiousDeedOfTrustFilename: 'sacramento.pdf',
    },
    {
        county: 'san benito',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san bernardino',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0485927',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'sanBernardino.pdf',
    },
    {
        county: 'san diego',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0810490',
        fictitiousDeedOfTrustDate: '12/17/2020',
        fictitiousDeedOfTrustFilename: 'sanDiego.pdf',
    },
    {
        county: 'san francisco',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020017229',
        fictitiousDeedOfTrustDate: '9/15/2020',
        fictitiousDeedOfTrustFilename: 'sanFrancisco.pdf',
    },
    {
        county: 'san fransisco',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020017229',
        fictitiousDeedOfTrustDate: '9/15/2020',
        fictitiousDeedOfTrustFilename: 'sanFrancisco.pdf',
    },
    {
        county: 'san joaquin',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '2020-167380',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'sanJoaquin.pdf',
    },
    {
        county: 'san luis obispo',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020071939',
        fictitiousDeedOfTrustDate: '12/7/2020',
        fictitiousDeedOfTrustFilename: 'sanLuisObispo.pdf',
    },
    {
        county: 'san mateo',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '2020-105814',
        fictitiousDeedOfTrustDate: '10/5/2020',
        fictitiousDeedOfTrustFilename: 'sanMateo.pdf',
    },
    {
        county: 'santa barbara',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0075760',
        fictitiousDeedOfTrustDate: '12/17/2020',
        fictitiousDeedOfTrustFilename: 'santaBarbara.pdf',
    },
    {
        county: 'santa clara',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '24641891',
        fictitiousDeedOfTrustDate: '10/5/2020',
        fictitiousDeedOfTrustFilename: 'santaClara.pdf',
    },
    {
        county: 'santa cruz',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0051475',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'santaCruz.pdf',
    },
    {
        county: 'shasta',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0043356',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'shasta.pdf',
    },
    {
        county: 'sierra',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'siskiyou',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'solano',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '202000110648',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'solano.pdf',
    },
    {
        county: 'sonoma',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020116238',
        fictitiousDeedOfTrustDate: '12/7/2020',
        fictitiousDeedOfTrustFilename: 'sonoma.pdf',
    },
    {
        county: 'stanislaus',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sutter',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tehama',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020015287',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'tehama.pdf',
    },
    {
        county: 'trinity',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tulare',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-0083653',
        fictitiousDeedOfTrustDate: '12/23/2020',
        fictitiousDeedOfTrustFilename: 'tulare.pdf',
    },
    {
        county: 'tuolumne',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020016052',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'tuolumne.pdf',
    },
    {
        county: 'ventura',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '20201202-00206190-0',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'ventura.pdf',
    },
    {
        county: 'yolo',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yuba',
        state: homeState_1.StateTwoLetterCodes.california,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '2020-020248',
        fictitiousDeedOfTrustDate: '12/2/2020',
        fictitiousDeedOfTrustFilename: 'yuba.pdf',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alamosa',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'arapahoe',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'archuleta',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baca',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bent',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boulder',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'broomfield',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chaffee',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cheyenne',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clear creek',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'conejos',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'costilla',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crowley',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'custer',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delta',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'denver',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dolores',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'eagle',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elbert',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'el paso',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fremont',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garfield',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gilpin',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grand',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gunnison',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hinsdale',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'huerfano',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kiowa',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kit carson',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'la plata',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'larimer',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'las animas',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mesa',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mineral',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'moffat',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montezuma',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montrose',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'otero',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ouray',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'park',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'phillips',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pitkin',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prowers',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pueblo',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rio blanco',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rio grande',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'routt',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saguache',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san juan',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san miguel',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sedgwick',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'summit',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'teller',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'weld',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yuma',
        state: homeState_1.StateTwoLetterCodes.colorado,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'andover',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'ansonia',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'towns of ashford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'avon',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'barkhamsted',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'beacon falls',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'berlin',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bethany',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bethel',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bethlehem',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bloomfield',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bolton',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bozrah',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'branford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bridgeport',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bridgewater',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'bristol',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'brookfield',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'brooklyn',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'burlington',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'canaan',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'canterbury',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'canton',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'chaplin',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'cheshire',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'chester',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'clinton',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'colchester',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'colebrook',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'columbia',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'cornwall',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'coventry',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'cromwell',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'danbury',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'darien',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'deep river',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'derby',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'durham',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'east granby',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'east haddam',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'east hampton',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'east hartford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'east haven',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'east lyme',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'east windsor',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'eastford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'easton',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'ellington',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'enfield',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'essex',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'fairfield',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'farmington',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'franklin',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'glastonbury',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'goshen',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'granby',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'greenwich',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'griswold',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'groton',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'guilford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'haddam',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'hamden',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'hampton',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'hartford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'hartland',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'harwinton',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'hebron',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'kent',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'killingly',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'killingworth',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'lebanon',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'ledyard',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'lisbon',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'litchfield',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'lyme',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'madison',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'manchester',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'mansfield',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'marlborough',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'meriden',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'middlebury',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'middlefield',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'middletown',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'milford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'monroe',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'montville',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'morris',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'new britain',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'new canaan',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'new fairfield',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'new hartford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'new haven',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'new london',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'new milford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'newington',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'newtown',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'norfolk',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'north branford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'north canaan',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'north haven',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'north stonington',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'norwalk',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'norwich',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'old lyme',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'old saybrook',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'orange',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'oxford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'plainfield',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'plainville',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'plymouth',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'pomfret',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'portland',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'preston',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'prospect',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'putnam',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'redding',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'ridgefield',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'rocky hill',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'roxbury',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'salem',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'salisbury',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'scotland',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'seymour',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'sharon',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'shelton',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'sherman',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'simsbury',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'somers',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'south windsor',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'southbury',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'southington',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'sprague',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'stafford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'stamford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'sterling',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'stonington',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'stratford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'suffield',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'thomaston',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'thompson',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'tolland',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'torrington',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'trumbull',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'union',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'vernon',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'voluntown',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'wallingford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'warren',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'washington',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'waterbury',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new london',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'waterford',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'watertown',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'west hartford',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'west haven',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'westbrook',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'weston',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'westport',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'wethersfield',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tolland',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'willington',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'wilton',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'winchester',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'windham',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'windsor',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartford',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'windsor locks',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'wolcott',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'woodbridge',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'litchfield',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'woodbury',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'woodstock',
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'capitol',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greater bridgeport',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lower connecticut river valley',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'naugatuck valley',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northeastern connecticut',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northwest hills',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'south central connecticut',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'southeastern connecticut',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'western connecticut',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new haven',
        state: homeState_1.StateTwoLetterCodes.connecticut,
        city: 'naugatuck',
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'kent',
        state: homeState_1.StateTwoLetterCodes.delaware,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new castle',
        state: homeState_1.StateTwoLetterCodes.delaware,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sussex',
        state: homeState_1.StateTwoLetterCodes.delaware,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'district of columbia',
        state: homeState_1.StateTwoLetterCodes.districtOfColumbia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alachua',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baker',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bay',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bradford',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brevard',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'broward',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charlotte',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'citrus',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'collier',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'de soto',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dixie',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'duval',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'escambia',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'flagler',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gadsden',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gilchrist',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'glades',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gulf',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hardee',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hendry',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hernando',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'highlands',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hillsborough',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'holmes',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'indian river',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lafayette',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'leon',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'levy',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'liberty',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manatee',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'martin',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miami-dade',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nassau',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'okaloosa',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'okeechobee',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'osceola',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'palm beach',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pasco',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pinellas',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. johns',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. lucie',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'santa rosa',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sarasota',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seminole',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sumter',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'suwannee',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taylor',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'volusia',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wakulla',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walton',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.florida,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'appling',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'atkinson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'bacon',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baker',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'baldwin',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'banks',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barrow',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bartow',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ben hill',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'berrien',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'bibb',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bleckley',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brantley',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brooks',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bryan',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bulloch',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burke',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butts',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'camden',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'candler',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'catoosa',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charlton',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chatham',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chattahoochee',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chattooga',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clarke',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clayton',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinch',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'cobb',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coffee',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'colquitt',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cook',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coweta',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crisp',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dade',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dawson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'decatur',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dekalb',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dodge',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dooly',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dougherty',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'early',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'echols',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'effingham',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elbert',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'emanuel',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'evans',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fannin',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'floyd',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'forsyth',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gilmer',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'glascock',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'glynn',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gordon',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grady',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gwinnett',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'habersham',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hall',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haralson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harris',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hart',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'heard',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'houston',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'irwin',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jeff davis',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jenkins',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jones',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lamar',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lanier',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'laurens',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'liberty',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'long',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lowndes',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lumpkin',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcduffie',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcintosh',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macon',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meriwether',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miller',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mitchell',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'murray',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'muscogee',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newton',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oconee',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oglethorpe',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'paulding',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'peach',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pickens',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pierce',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'pulaski',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'quitman',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rabun',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richmond',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockdale',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schley',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'screven',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seminole',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'spalding',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stephens',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stewart',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sumter',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'talbot',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taliaferro',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tattnall',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taylor',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'telfair',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'terrell',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'thomas',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tift',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'toombs',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'towns',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'treutlen',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'troup',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'turner',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'twiggs',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'upson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walker',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walton',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ware',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wheeler',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'white',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'whitfield',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilcox',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilkes',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilkinson',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'worth',
        state: homeState_1.StateTwoLetterCodes.georgia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hawaii',
        state: homeState_1.StateTwoLetterCodes.hawaii,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'honolulu',
        state: homeState_1.StateTwoLetterCodes.hawaii,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kalawao',
        state: homeState_1.StateTwoLetterCodes.hawaii,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'maui',
        state: homeState_1.StateTwoLetterCodes.hawaii,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kauai',
        state: homeState_1.StateTwoLetterCodes.hawaii,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ada',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bannock',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bear lake',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benewah',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bingham',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blaine',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boise',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bonner',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bonneville',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boundary',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butte',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'camas',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'canyon',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caribou',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cassia',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clearwater',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'custer',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elmore',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fremont',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gem',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gooding',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'idaho',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jerome',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kootenai',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'latah',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lemhi',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lewis',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'minidoka',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nez perce',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oneida',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'owyhee',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'payette',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'power',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shoshone',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'teton',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'twin falls',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'valley',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.idaho,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adair',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allamakee',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'appanoose',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'audubon',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'black hawk',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bremer',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buchanan',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buena vista',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cedar',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cerro gordo',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chickasaw',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clarke',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clayton',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dallas',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'davis',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'decatur',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delaware',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'des moines',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dickinson',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dubuque',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'emmet',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'floyd',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fremont',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grundy',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'guthrie',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hardin',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howard',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'humboldt',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ida',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iowa',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jones',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'keokuk',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kossuth',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'linn',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'louisa',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lucas',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lyon',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mahaska',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mills',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mitchell',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monona',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'muscatine',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: "o'brien",
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'osceola',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'page',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'palo alto',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'plymouth',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pocahontas',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pottawattamie',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'poweshiek',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ringgold',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sac',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sioux',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'story',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tama',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taylor',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'van buren',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wapello',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winnebago',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winneshiek',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woodbury',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'worth',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wright',
        state: homeState_1.StateTwoLetterCodes.iowa,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alexander',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bond',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bureau',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'champaign',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'christian',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coles',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cook',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'de kalb',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'de witt',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dupage',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edgar',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edwards',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'effingham',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ford',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gallatin',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grundy',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hardin',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henderson',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iroquois',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jersey',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jo daviess',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kane',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kankakee',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kendall',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'la salle',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'livingston',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcdonough',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mc henry',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mclean',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macon',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macoupin',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mason',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'massac',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'menard',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'moultrie',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ogle',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pembroke township',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'peoria',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'piatt',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pope',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pulaski',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richland',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rock island',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. clair',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saline',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sangamon',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schuyler',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stark',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stephenson',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tazewell',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vermilion',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wabash',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'white',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'whiteside',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'will',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'williamson',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'true',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winnebago',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woodford',
        state: homeState_1.StateTwoLetterCodes.illinois,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allen',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bartholomew',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blackford',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'daviess',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dearborn',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'decatur',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dekalb',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delaware',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dubois',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elkhart',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'floyd',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fountain',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gibson',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hendricks',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howard',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'huntington',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jay',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jennings',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kosciusko',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lagrange',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'laporte',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'martin',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miami',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newton',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'noble',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ohio',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'owen',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'parke',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'porter',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'posey',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pulaski',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ripley',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rush',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. joseph',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'spencer',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'starke',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'steuben',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sullivan',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'switzerland',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tippecanoe',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tipton',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vanderburgh',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vermillion',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vigo',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wabash',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warrick',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wells',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'white',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'whitley',
        state: homeState_1.StateTwoLetterCodes.indiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allen',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anderson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'atchison',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barber',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barton',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bourbon',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chase',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chautauqua',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cheyenne',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cloud',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coffey',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'comanche',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cowley',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'decatur',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dickinson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'doniphan',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edwards',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elk',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ellis',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ellsworth',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'finney',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ford',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'geary',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gove',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'graham',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gray',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greeley',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greenwood',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harper',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harvey',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haskell',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hodgeman',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jewell',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kearny',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kingman',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kiowa',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'labette',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lane',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'leavenworth',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'linn',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lyon',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcpherson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meade',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miami',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mitchell',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morris',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morton',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nemaha',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'neosho',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ness',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'norton',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'osage',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'osborne',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ottawa',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pawnee',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'phillips',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pottawatomie',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pratt',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rawlins',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'reno',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'republic',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rice',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'riley',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rooks',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rush',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'russell',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saline',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sedgwick',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seward',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shawnee',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sheridan',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sherman',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'smith',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stafford',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stanton',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stevens',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sumner',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'thomas',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'trego',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wabaunsee',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wallace',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wichita',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woodson',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wyandotte',
        state: homeState_1.StateTwoLetterCodes.kansas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adair',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allen',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anderson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ballard',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barren',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bath',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bell',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bourbon',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boyd',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boyle',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bracken',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'breathitt',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'breckinridge',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bullitt',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caldwell',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calloway',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'campbell',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carlisle',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carter',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'casey',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'christian',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crittenden',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'daviess',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edmonson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elliott',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'estill',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fleming',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'floyd',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gallatin',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garrard',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'graves',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grayson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'green',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greenup',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hardin',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harlan',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hart',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henderson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hickman',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hopkins',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jessamine',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kenton',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knott',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'larue',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'laurel',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'leslie',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'letcher',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lewis',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'livingston',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lyon',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mccracken',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mccreary',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mclean',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'magoffin',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'martin',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mason',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meade',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'menifee',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'metcalfe',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'muhlenberg',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nelson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nicholas',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ohio',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oldham',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'owen',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'owsley',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pendleton',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'powell',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pulaski',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'robertson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockcastle',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rowan',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'russell',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'simpson',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'spencer',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taylor',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'todd',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'trigg',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'trimble',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'whitley',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wolfe',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woodford',
        state: homeState_1.StateTwoLetterCodes.kentucky,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'acadia',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allen',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ascension',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'assumption',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'avoyelles',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beauregard',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bienville',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bossier',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caddo',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calcasieu',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caldwell',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cameron',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'catahoula',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'claiborne',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'concordia',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'de soto',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'east baton rouge',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'east carroll',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'east feliciana',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'evangeline',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iberia',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iberville',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson davis',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lafayette',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lafourche',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'la salle',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'livingston',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morehouse',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'natchitoches',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orleans',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ouachita',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'plaquemines',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pointe coupee',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rapides',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'red river',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richland',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sabine',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. bernard',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. charles',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. helena',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. james',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. john the baptist',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. landry',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. martin',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. mary',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. tammany',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tangipahoa',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tensas',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'terrebonne',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vermilion',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vernon',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'west baton rouge',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'west carroll',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'west feliciana',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winn',
        state: homeState_1.StateTwoLetterCodes.louisiana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'androscoggin',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aroostook',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kennebec',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oxford',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'penobscot',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'piscataquis',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sagadahoc',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'somerset',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'waldo',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'york',
        state: homeState_1.StateTwoLetterCodes.maine,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allegany',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anne arundel',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baltimore county',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baltimore city',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calvert',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caroline',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cecil',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charles',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dorchester',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'frederick',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garrett',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harford',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howard',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kent',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prince georges',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'queen annes',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. marys',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'somerset',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'talbot',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wicomico',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'worcester',
        state: homeState_1.StateTwoLetterCodes.maryland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: null,
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barnstable',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'berkshire',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bristol',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dukes',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'essex',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hampden',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hampshire',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nantucket',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'norfolk',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'plymouth',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'suffolk',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'worcester',
        state: homeState_1.StateTwoLetterCodes.massachusetts,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alcona',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alger',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allegan',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alpena',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'antrim',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'arenac',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baraga',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barry',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bay',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benzie',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'berrien',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'branch',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charlevoix',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cheboygan',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chippewa',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clare',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delta',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dickinson',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'eaton',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'emmet',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'genesee',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gladwin',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gogebic',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grand traverse',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gratiot',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison twp',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hillsdale',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'houghton',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'huron',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ingham',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ionia',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iosco',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iron',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'isabella',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kalamazoo',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kalkaska',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kent',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'keweenaw',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lapeer',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'leelanau',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lenawee',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'livingston',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'luce',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mackinac',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macomb',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manistee',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marquette',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mason',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mecosta',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'menominee',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'midland',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'missaukee',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montcalm',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montmorency',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'muskegon',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newaygo',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oakland',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oceana',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ogemaw',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ontonagon',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'osceola',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oscoda',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'otsego',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ottawa',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'presque isle',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roscommon',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saginaw',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby township',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. clair',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. joseph',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sanilac',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schoolcraft',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shiawassee',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tuscola',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'van buren',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washtenaw',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wexford',
        state: homeState_1.StateTwoLetterCodes.michigan,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aitkin',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anoka',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'becker',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beltrami',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'big stone',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blue earth',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carlton',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carver',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chippewa',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chisago',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clearwater',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cook',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cottonwood',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crow wing',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dakota',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dodge',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'faribault',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fillmore',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'freeborn',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'goodhue',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hennepin',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'houston',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hubbard',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'isanti',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'itasca',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kanabec',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kandiyohi',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kittson',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'koochiching',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lac qui parle',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake of the woods',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'le sueur',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lyon',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcleod',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mahnomen',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'martin',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meeker',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mille lacs',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morrison',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mower',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'murray',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nicollet',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nobles',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'norman',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'olmsted',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'otter tail',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pennington',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pine',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pipestone',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pope',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ramsey',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'red lake',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'redwood',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'renville',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rice',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rock',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roseau',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. louis',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sherburne',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sibley',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stearns',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'steele',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stevens',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'swift',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'todd',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'traverse',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wabasha',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wadena',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'waseca',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'watonwan',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilkin',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winona',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wright',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yellow medicine',
        state: homeState_1.StateTwoLetterCodes.minnesota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alcorn',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'amite',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'attala',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bolivar',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chickasaw',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'choctaw',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'claiborne',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clarke',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coahoma',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'copiah',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'covington',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'desoto',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'forrest',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'george',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grenada',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hinds',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'holmes',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'humphreys',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'issaquena',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'itawamba',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson davis',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jones',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kemper',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lafayette',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lamar',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lauderdale',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'leake',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'leflore',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lowndes',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'neshoba',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newton',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'noxubee',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oktibbeha',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'panola',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pearl river',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pontotoc',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prentiss',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'quitman',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rankin',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sharkey',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'simpson',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'smith',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stone',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sunflower',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tallahatchie',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tate',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tippah',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tishomingo',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tunica',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walthall',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilkinson',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winston',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yalobusha',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yazoo',
        state: homeState_1.StateTwoLetterCodes.mississippi,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adair',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'andrew',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'atchison',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'audrain',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barry',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barton',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bates',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bollinger',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buchanan',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caldwell',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'callaway',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'camden',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cape girardeau',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carter',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cedar',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chariton',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'christian',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cole',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cooper',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dade',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dallas',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'daviess',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dekalb',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dent',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dunklin',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gasconade',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gentry',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grundy',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hickory',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'holt',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howard',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howell',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iron',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'laclede',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lafayette',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lewis',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'linn',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'livingston',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcdonald',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macon',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'maries',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miller',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mississippi',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'moniteau',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new madrid',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newton',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nodaway',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oregon',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'osage',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ozark',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pemiscot',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pettis',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'phelps',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'platte',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pulaski',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ralls',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ray',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'reynolds',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ripley',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. charles',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. clair',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ste. genevieve',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. francois',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'city of st. louis',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. louis city',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. louis',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saline',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schuyler',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scotland',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shannon',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stoddard',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stone',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sullivan',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taney',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'texas',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vernon',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'worth',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wright',
        state: homeState_1.StateTwoLetterCodes.missouri,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beaverhead',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'big horn',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blaine',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'broadwater',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carbon',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carter',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cascade',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chouteau',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'custer',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'daniels',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dawson',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'deer lodge',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fallon',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fergus',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'flathead',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gallatin',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garfield',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'glacier',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'golden valley',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'granite',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hill',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'judith basin',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lewis and clark',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'liberty',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mccone',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meagher',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mineral',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'missoula',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'musselshell',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'park',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'petroleum',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'phillips',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pondera',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'powder river',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'powell',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prairie',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ravalli',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richland',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roosevelt',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rosebud',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sanders',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sheridan',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'silver bow',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stillwater',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sweet grass',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'teton',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'toole',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'treasure',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'valley',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wheatland',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wibaux',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yellowstone',
        state: homeState_1.StateTwoLetterCodes.montana,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'antelope',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'arthur',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'banner',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blaine',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'box butte',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boyd',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buffalo',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burt',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cedar',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chase',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherry',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cheyenne',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'colfax',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cuming',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'custer',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dakota',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dawes',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dawson',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'deuel',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dixon',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dodge',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dundy',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fillmore',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'frontier',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'furnas',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gage',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garden',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garfield',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gosper',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greeley',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hall',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harlan',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hayes',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hitchcock',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'holt',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hooker',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howard',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kearney',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'keith',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'keya paha',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kimball',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lancaster',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'loup',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcpherson',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'merrick',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morrill',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nance',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nemaha',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nuckolls',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'otoe',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pawnee',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perkins',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'phelps',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pierce',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'platte',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'red willow',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richardson',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rock',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saline',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sarpy',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saunders',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scotts bluff',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seward',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sheridan',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sherman',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sioux',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stanton',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'thayer',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'thomas',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'thurston',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'valley',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wheeler',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'york',
        state: homeState_1.StateTwoLetterCodes.nebraska,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carson city',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'churchill',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elko',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'esmeralda',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'eureka',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'humboldt',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lander',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lyon',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mineral',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nye',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pershing',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'storey',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washoe',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'white pine',
        state: homeState_1.StateTwoLetterCodes.nevada,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'belknap',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cheshire',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coos',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grafton',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hillsborough',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'merrimack',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockingham',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'strafford',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sullivan',
        state: homeState_1.StateTwoLetterCodes.newHampshire,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'atlantic',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bergen',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burlington',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'camden',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cape may',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'essex',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gloucester',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hudson',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hunterdon',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monmouth',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morris',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new york county',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ocean',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'passaic',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'salem',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'somerset',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sussex',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.newJersey,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bernalillo',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'catron',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chaves',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cibola',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'colfax',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'curry',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'de baca',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dona ana',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'eddy',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'guadalupe',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harding',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hidalgo',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lea',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'los alamos',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'luna',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mckinley',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mora',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'otero',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'quay',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rio arriba',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roosevelt',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sandoval',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san juan',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san miguel',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'santa fe',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sierra',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'socorro',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taos',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'torrance',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'valencia',
        state: homeState_1.StateTwoLetterCodes.newMexico,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'albany',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allegany',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bronx',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'broome',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cattaraugus',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cayuga',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chautauqua',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chemung',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chenango',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cortland',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delaware',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dutchess',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'erie',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'essex',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'genesee',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'herkimer',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kings',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brooklyn',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lewis',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'livingston',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nassau',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new york',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manhattan',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'niagara',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oneida',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'onondaga',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ontario',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orleans',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oswego',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'otsego',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'queens',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rensselaer',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richmond',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockland',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. lawrence',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saratoga',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schenectady',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schoharie',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schuyler',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seneca',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'staten island (richmond)',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'steuben',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'suffolk',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sullivan',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tioga',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tompkins',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ulster',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'westchester',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wyoming',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yates',
        state: homeState_1.StateTwoLetterCodes.newYork,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alamance',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alexander',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alleghany',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anson',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ashe',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'avery',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beaufort',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bertie',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bladen',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brunswick',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buncombe',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burke',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cabarrus',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caldwell',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'camden',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carteret',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caswell',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'catawba',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chatham',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chowan',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cleveland',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbus',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'craven',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'currituck',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dare',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'davidson',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'davie',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'duplin',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'durham',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edgecombe',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'forsyth',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gaston',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gates',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'graham',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'granville',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'guilford',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'halifax',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harnett',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haywood',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henderson',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hertford',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hoke',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hyde',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iredell',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnston',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jones',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lenoir',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcdowell',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macon',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'martin',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mecklenburg',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mitchell',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'moore',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nash',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new hanover',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northampton',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'onslow',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pamlico',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pasquotank',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pender',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perquimans',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'person',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pitt',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richmond',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'robeson',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockingham',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rowan',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rutherford',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sampson',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scotland',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stanly',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stokes',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'surry',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'swain',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'transylvania',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tyrrell',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vance',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wake',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'watauga',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilkes',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilson',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yadkin',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yancey',
        state: homeState_1.StateTwoLetterCodes.northCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barnes',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benson',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'billings',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bottineau',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bowman',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burke',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burleigh',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cavalier',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dickey',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'divide',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dunn',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'eddy',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'emmons',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'foster',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'golden valley',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grand forks',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'griggs',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hettinger',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kidder',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lamoure',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mchenry',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcintosh',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mckenzie',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mclean',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morton',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mountrail',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nelson',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oliver',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pembina',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pierce',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ramsey',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ransom',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'renville',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richland',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rolette',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sargent',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sheridan',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sioux',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'slope',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stark',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'steele',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stutsman',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'towner',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'traill',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walsh',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ward',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wells',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'williams',
        state: homeState_1.StateTwoLetterCodes.northDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allen',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ashland',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ashtabula',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'athens',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'auglaize',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'belmont',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'champaign',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clermont',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbiana',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coshocton',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cuyahoga',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'darke',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'defiance',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delaware',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'erie',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gallia',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'geauga',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'guernsey',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hardin',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'highland',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hocking',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'holmes',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'huron',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'liberty township',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'licking',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lorain',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lucas',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mahoning',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'medina',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meigs',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miami',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morrow',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'muskingum',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'noble',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ottawa',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'paulding',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pickaway',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'portage',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'preble',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richland',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ross',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sandusky',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scioto',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seneca',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stark',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'summit',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'trumbull',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tuscarawas',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'van wert',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vinton',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'williams',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wood',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wyandot',
        state: homeState_1.StateTwoLetterCodes.ohio,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adair',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alfalfa',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'atoka',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beaver',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beckham',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blaine',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bryan',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caddo',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'canadian',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carter',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'choctaw',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cimarron',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cleveland',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coal',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'comanche',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cotton',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'craig',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'creek',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'custer',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delaware',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dewey',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ellis',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garfield',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garvin',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grady',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greer',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harmon',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harper',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haskell',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hughes',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnston',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kay',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kingfisher',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kiowa',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'latimer',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'le flore',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'love',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcclain',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mccurtain',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcintosh',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'major',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mayes',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'murray',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'muskogee',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'noble',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nowata',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'okfuskee',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oklahoma',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'okmulgee',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'osage',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ottawa',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pawnee',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'payne',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pittsburg',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pontotoc',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pottawatomie',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pushmataha',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roger mills',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rogers',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'seminole',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sequoyah',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stephens',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'texas',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tillman',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tulsa',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wagoner',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washita',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woods',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woodward',
        state: homeState_1.StateTwoLetterCodes.oklahoma,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baker',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clackamas',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clatsop',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coos',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crook',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'curry',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'deschutes',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gilliam',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harney',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hood river',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'josephine',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'klamath',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lane',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'linn',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'malheur',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morrow',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'multnomah',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sherman',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tillamook',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'umatilla',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wallowa',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wasco',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wheeler',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yamhill',
        state: homeState_1.StateTwoLetterCodes.oregon,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allegheny',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'armstrong',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aston township',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beaver',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bedford',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'berks',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blair',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bradford',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bucks',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butler',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cambria',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cameron',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carbon',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'centre',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chester',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clarion',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clearfield',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clifton township',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clinton',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dauphin',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delaware',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'elk',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'erie',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'forest',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fulton',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hampden township',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'huntingdon',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'indiana',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'juniata',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lackawanna',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lancaster',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lebanon',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lehigh',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'luzerne',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lycoming',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mckean',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mifflin',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montour',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northampton',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northumberland',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'philadelphia',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pike',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'potter',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'schuylkill',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'snyder',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'somerset',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sullivan',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'susquehanna',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tioga',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'upper moreland township',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'venango',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'westmoreland',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wyoming',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'york',
        state: homeState_1.StateTwoLetterCodes.pennsylvania,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barrington',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bristol',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burrillville',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'central falls',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charlestown',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coventry',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cranston',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'east greenwich',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'east providence',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'exeter',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'foster',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'glocester',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hopkinton',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jamestown',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnston',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kent',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'little compton',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middletown',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'narragansett',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new shoreham',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newport',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'north kingstown',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'north providence',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'north smithfield',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pawtucket',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'portsmouth',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'providence',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richmond',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scituate',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'smithfield',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'south kingstown',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tiverton',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warwick',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'west greenwich',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'west warwick',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'westerly',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'woonsocket',
        state: homeState_1.StateTwoLetterCodes.rhodeIsland,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'abbeville',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'aiken',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'allendale',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'anderson',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bamberg',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'barnwell',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'beaufort',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'berkeley',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charleston',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chester',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chesterfield',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clarendon',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'colleton',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'darlington',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dillon',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'dorchester',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edgefield',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fairfield',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'florence',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'georgetown',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greenville',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greenwood',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hampton',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'horry',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kershaw',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lancaster',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'laurens',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'lexington',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mccormick',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'marlboro',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'newberry',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'oconee',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orangeburg',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pickens',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richland',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'saluda',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'spartanburg',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sumter',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'williamsburg',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'york',
        state: homeState_1.StateTwoLetterCodes.southCarolina,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aurora',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'beadle',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bennett',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bon homme',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brookings',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brule',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buffalo',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'butte',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'campbell',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charles mix',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'codington',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'corson',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'custer',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'davison',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'day',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'deuel',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dewey',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edmunds',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fall river',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'faulk',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gregory',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haakon',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamlin',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hand',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hanson',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harding',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hughes',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hutchinson',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hyde',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jerauld',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jones',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kingsbury',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lyman',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mccook',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcpherson',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meade',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mellette',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'miner',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'minnehaha',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'moody',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oglala lakota',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pennington',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perkins',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'potter',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roberts',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sanborn',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'spink',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stanley',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sully',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'todd',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tripp',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'turner',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walworth',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yankton',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ziebach',
        state: homeState_1.StateTwoLetterCodes.southDakota,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anderson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bedford',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bledsoe',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blount',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bradley',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'campbell',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cannon',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carter',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cheatham',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chester',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'claiborne',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cocke',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coffee',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crockett',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'davidson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'decatur',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dekalb',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dickson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dyer',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fentress',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gibson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'giles',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grainger',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grundy',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamblen',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hardeman',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hardin',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hawkins',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haywood',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henderson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hickman',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'houston',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'humphreys',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lake',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lauderdale',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lawrence',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lewis',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'loudon',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mc minn',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcnairy',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'macon',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'maury',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'meigs',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'moore',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'obion',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'overton',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'perry',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pickett',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rhea',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roane',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'robertson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rutherford',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sequatchie',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sevier',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'smith',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stewart',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sullivan',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sumner',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tipton',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'trousdale',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'unicoi',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'union',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'van buren',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'weakley',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'white',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'williamson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilson',
        state: homeState_1.StateTwoLetterCodes.tennessee,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'anderson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'andrews',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'angelina',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'aransas',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'archer',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'armstrong',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'atascosa',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'austin',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bailey',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'bandera',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'bastrop',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'baylor',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'bee',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bell',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bexar',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'blanco',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'borden',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'bosque',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bowie',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'brazoria',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brazos',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brewster',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'briscoe',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'brooks',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'burleson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'burnet',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caldwell',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'callahan',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'cameron',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'camp',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'carson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cass',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'castro',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'chambers',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cherokee',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'childress',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cochran',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'coke',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coleman',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'collin',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'collingsworth',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'colorado',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'comal',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'comanche',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'concho',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'cooke',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'coryell',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cottle',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'crane',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'crockett',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'crosby',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'culberson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'dallam',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dallas',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dawson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'deaf smith',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'delta',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'denton',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dewitt',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'dickens',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'dimmit',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'donley',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'duval',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'eastland',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ector',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'edwards',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'ellis',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'el paso',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'erath',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'falls',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fannin',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fisher',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'floyd',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'foard',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fort bend',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'freestone',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'frio',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'gaines',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'galveston',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garza',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'gillespie',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'glasscock',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'goliad',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'gonzales',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'gray',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'grayson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gregg',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grimes',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'guadalupe',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hale',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hall',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hamilton',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hansford',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hardeman',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hardin',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'harris',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hartley',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'haskell',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hays',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hemphill',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henderson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hidalgo',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hill',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hockley',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hood',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hopkins',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'houston',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'howard',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hudspeth',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hunt',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hutchinson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'irion',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'jack',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'jasper',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'jeff davis',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jim hogg',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jim wells',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jones',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'karnes',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'kaufman',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kendall',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kenedy',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kent',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'kerr',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kimble',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'king',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'kinney',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'kleberg',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'knox',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'lamar',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lamb',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'lampasas',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'la salle',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'lavaca',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'leon',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'liberty',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'limestone',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lipscomb',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'live oak',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'llano',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'loving',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lubbock',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lynn',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'mcculloch',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'mclennan',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mcmullen',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'martin',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'mason',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'matagorda',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'maverick',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'medina',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'menard',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'midland',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'milam',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mills',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'mitchell',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'montague',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'moore',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'morris',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'motley',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'nacogdoches',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'navarro',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newton',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'nolan',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nueces',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ochiltree',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'oldham',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'palo pinto',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'panola',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'parker',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'parmer',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'pecos',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'potter',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'presidio',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'rains',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'randall',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'reagan',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'real',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'red river',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'reeves',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'refugio',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roberts',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'robertson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockwall',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'runnels',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'rusk',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'sabine',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'san augustine',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'san jacinto',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'san patricio',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san saba',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'schleicher',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'scurry',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shackelford',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'shelby',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'sherman',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'smith',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'somervell',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'starr',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stephens',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'sterling',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'stonewall',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sutton',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'swisher',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tarrant',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taylor',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'terrell',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'terry',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'throckmorton',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'titus',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tom green',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'travis',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'trinity',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tyler',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'upshur',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'upton',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'uvalde',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'val verde',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'van zandt',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'victoria',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walker',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'waller',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ward',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'webb',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wharton',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wheeler',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wichita',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilbarger',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'willacy',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'williamson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wilson',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winkler',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wise',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wood',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yoakum',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'young',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'zapata',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'zavala',
        state: homeState_1.StateTwoLetterCodes.texas,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'beaver',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'box elder',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cache',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carbon',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'daggett',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'davis',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'duchesne',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'emery',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garfield',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grand',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iron',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'juab',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kane',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'millard',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'piute',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rich',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'salt lake',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san juan',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sanpete',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sevier',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'summit',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tooele',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'uintah',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'utah',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wasatch',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'weber',
        state: homeState_1.StateTwoLetterCodes.utah,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'addison',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bennington',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caledonia',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chittenden',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'essex',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grand isle',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lamoille',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orleans',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rutland',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windham',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'windsor',
        state: homeState_1.StateTwoLetterCodes.vermont,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'accomack',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'albemarle',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alexandria city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alexandria',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'alleghany',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'amelia',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'amherst',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'appomattox',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'arlington',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'augusta',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bath',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bedford',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bland',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'botetourt',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bristol city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brunswick',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buchanan',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buckingham',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buena vista city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'campbell',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'caroline',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carroll',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charles city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charlotte',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'charlottesville city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chesapeake city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chesterfield',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clarke',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'colonial heights city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'covington city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'craig',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'culpeper',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cumberland',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'danville city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dickenson',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dinwiddie',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'emporia city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'essex',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfax',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fairfax city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'falls church city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fauquier',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'floyd',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fluvanna',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'frederick',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fredericksburg city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fredericksburg',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'galax city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'giles',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gloucester',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'goochland',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grayson',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greene',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greensville',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'halifax',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hampton city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hanover',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrisonburg city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henrico',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'henry',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'highland',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hopewell city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'isle of wight',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'james city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'king and queen',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'king george',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'king william',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lancaster',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lee',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lexington city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'loudoun',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'louisa',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lunenburg',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lunenberg',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lynchburg city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'madison',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manassas city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manassas lake city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manassas park city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'martinsville city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mathews',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mecklenburg',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'middlesex',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'montgomery',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nelson',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'new kent',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'newport news city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'norfolk city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northampton',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'northumberland',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'norton city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'nottoway',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'orange',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'page',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'patrick',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'petersburg city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pittsylvania',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'poquoson city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'portsmouth city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'powhatan',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prince edward',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prince george',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'prince william',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pulaski',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'radford city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'radford',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rappahannock',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richmond',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richmond city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roanoke',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'roanoke city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockbridge',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rockingham',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'russell',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'salem city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'salem',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'scott',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shenandoah',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'smyth',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'southampton',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'spotsylvania',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stafford',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'staunton city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'suffolk city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'surry',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sussex',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tazewell',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'virginia beach city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'warren',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'waynesboro city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'westmoreland',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'williamsburg city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winchester city',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wise',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wythe',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'york',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'york/poquoson',
        state: homeState_1.StateTwoLetterCodes.virginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'asotin',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'benton',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chelan',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clallam',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cowlitz',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ferry',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'franklin',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'garfield',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grays harbor',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'island',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'king',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kitsap',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kittitas',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'klickitat',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lewis',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mason',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'okanogan',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pacific',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pend oreille',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pierce',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'san juan',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'skagit',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'skamania',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'snohomish',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'spokane',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'stevens',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'thurston',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wahkiakum',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walla walla',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'whatcom',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'whitman',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'yakima',
        state: homeState_1.StateTwoLetterCodes.washington,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barbour',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'berkeley',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'boone',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'braxton',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'brooke',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'cabell',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calhoun',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'clay',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'doddridge',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'fayette',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'gilmer',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'greenbrier',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hampshire',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hancock',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'hardy',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'harrison',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kanawha',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'lewis',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'logan',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'mcdowell',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'marion',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'marshall',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mason',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mercer',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'mineral',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'mingo',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'monongalia',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'morgan',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'nicholas',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'ohio',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'pendleton',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'pleasants',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'pocahontas',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'preston',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'putnam',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'raleigh',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'randolph',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ritchie',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'roane',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'summers',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taylor',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'tucker',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'tyler',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'upshur',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wayne',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'webster',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wetzel',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wirt',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wood',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
        lienRecordingFormat: LienRecordingFormat.PAPER,
    },
    {
        county: 'wyoming',
        state: homeState_1.StateTwoLetterCodes.westVirginia,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'adams',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ashland',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'barron',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'bayfield',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'brown',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'buffalo',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'burnett',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'calumet',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'chippewa',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'clark',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'columbia',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crawford',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dane',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dodge',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'door',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'douglas',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'dunn',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'eau claire',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'florence',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fond du lac',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'forest',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'grant',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'green',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'green lake',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iowa',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'iron',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jackson',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'jefferson',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'juneau',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kenosha',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'kewaunee',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'la crosse',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lafayette',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'langlade',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'manitowoc',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marathon',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marinette',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'marquette',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'menominee',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'milwaukee',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'monroe',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oconto',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'oneida',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'outagamie',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'ozaukee',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pepin',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'pierce',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'polk',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'portage',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'price',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'racine',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'richland',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rock',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'rusk',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'st. croix',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sauk',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sawyer',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'shawano',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sheboygan',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'taylor',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'trempealeau',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vernon',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'vilas',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'walworth',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washburn',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washington',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'waukesha',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'waupaca',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'waushara',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'winnebago',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'wood',
        state: homeState_1.StateTwoLetterCodes.wisconsin,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'albany',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'big horn',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'campbell',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'carbon',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'converse',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'crook',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'fremont',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'goshen',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'hot springs',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'johnson',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'laramie',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'lincoln',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'natrona',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'niobrara',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'park',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RIN,
        useGeneratedPropertyDescription: 'false',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'platte',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sheridan',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sublette',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'sweetwater',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'teton',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'uinta',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'washakie',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
    {
        county: 'weston',
        state: homeState_1.StateTwoLetterCodes.wyoming,
        sessionType: notarization_1.SessionType.RON,
        useGeneratedPropertyDescription: '',
        fictitiousDeedOfTrustNumber: '',
        fictitiousDeedOfTrustDate: '',
        fictitiousDeedOfTrustFilename: '',
    },
];
